import React from "react"
import styled from "styled-components"
import { Link } from "gatsby"
import NavOptions from "./NavOptions"
import Socials from "./Socials"
import Bag from "./Bag"

const DesktopNav = () => {
  return (
    <>
      <Bag />
      <Container>
        <Logo to="/">
          <h1>Giovanni Vitali</h1>
          <h2>photography</h2>
        </Logo>
        <nav>
          <NavOptions />
        </nav>
        <Socials />
      </Container>
    </>
  )
}

export default DesktopNav

const Container = styled.div`
  height: 100vh;
  width: 25vw;
  max-width: 350px;
  position: fixed;

  nav {
    margin-top: 5vh;
  }
`

const Logo = styled(Link)`
  color: #000;
  text-decoration: none;
  text-align: center;

  h1,
  h2 {
    font-family: "julius sans one", serif;
  }

  h1 {
    font-size: clamp(2.2rem, 3vw, 2.7rem);
  }

  h2 {
    font-size: clamp(1.5rem, 2vw, 1.7rem);
  }
`
